import { render, staticRenderFns } from "./PainelItemVisualizacao.vue?vue&type=template&id=915d9ea2&scoped=true"
import script from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelItemVisualizacao.vue?vue&type=style&index=0&id=915d9ea2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915d9ea2",
  null
  
)

export default component.exports